import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { AppConfigService } from './app.configservice';

@Injectable({
  providedIn: 'root'
})
export class CryptoService {

  // This should match your backend's base64 key string
  private base64Key = '8Nn1QPPtNlhO7tzUj7bOk8Lh2ZggfuosN7/noLoerKM=';

  constructor(private _appService: AppConfigService) { }
  /**
   * Encrypts text to match the C# AES implementation
   */
  encrypt(plainText: string): string {
    if (!this._appService.isAesEnabled) {
      return plainText;
    }
    // Convert Base64 key to WordArray (binary form)
    const key = CryptoJS.enc.Base64.parse(this.base64Key);

    // Generate random 16-byte IV
    const iv = CryptoJS.lib.WordArray.random(16);

    // Perform AES encryption
    const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(plainText), key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    // Combine IV + ciphertext (like in your C# code)
    const combined = iv.clone().concat(encrypted.ciphertext);

    // Return as Base64 string
    return CryptoJS.enc.Base64.stringify(combined);
  }

  /**
   * Decrypts text encrypted by the C# backend
   */
  decrypt(base64Data: string): string {
    if (!this._appService.isAesEnabled) {
      return base64Data;
    }
    if (base64Data === null || base64Data === undefined || base64Data.trim() === "") {
      return base64Data;
    }
    const base64Regex = /^[A-Za-z0-9+/=]+$/;
    if (!base64Regex.test(base64Data)) {
      //console.log("Data is not base64 string!!!", base64Data);
      return base64Data;
    }
    else {
      const key = CryptoJS.enc.Base64.parse(this.base64Key);

      // Decode Base64 input to raw bytes
      const combined = CryptoJS.enc.Base64.parse(base64Data);

      // Extract IV (first 16 bytes)
      const iv = CryptoJS.lib.WordArray.create(
        combined.words.slice(0, 4),
        16
      );

      // Extract ciphertext (remaining bytes)
      const ciphertext = CryptoJS.lib.WordArray.create(
        combined.words.slice(4),
        combined.sigBytes - 16
      );

      // Decrypt using same parameters
      const decrypted = CryptoJS.AES.decrypt({ ciphertext }, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });

      return CryptoJS.enc.Utf8.stringify(decrypted);
    }
  }


}
